import common from './common.json';
import createSpace from './create-space.json';
import editSpace from './edit-space.json';
import floorPlanner from './floor-planner.json';

export default {
  common,
  createSpace,
  editSpace,
  floorPlanner,
};
